import Icon from '../components/Icon.vue'

Icon.register({"arrow-circle-down":{"width":512,"height":512,"paths":[{"d":"M504 256C504 393 393 504 256 504S8 393 8 256 119 8 256 8 504 119 504 256zM360.4 227.1L288 302.6V120C288 106.7 277.3 96 264 96H248C234.7 96 224 106.7 224 120V302.6L151.6 227.1C142.3 217.4 126.8 217.2 117.3 226.7L106.4 237.7C97 247.1 97 262.3 106.4 271.6L239 404.3C248.4 413.7 263.6 413.7 272.9 404.3L405.6 271.6C415 262.2 415 247 405.6 237.7L394.7 226.7C385.2 217.2 369.7 217.4 360.4 227.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/arrow-circle-down.js
// module id = null
// module chunks = 